// extracted by mini-css-extract-plugin
export default {"counterContainer":"counter_counterContainer__RMZfk","count":"counter_count__5q1V0"};